import { GridColDef } from "@mui/x-data-grid-pro";
import ItemStatus from "../../../../../../common/components/item_status";


export const GenerateSaldoBancarioCadastroColumns = ():
    GridColDef[] => {


    //#region  TIPO
    const computeItemStatusTitle = (status: number) => {
        switch (status) {
            case 2:
            case 3:
            case 6:
                return "Débito";
            case 1:
            case 4:
            case 5:
                return "Crédito";
            default:
                return "D";
        }
    };

    const computeItemStatusColor = (status: number) => {
        switch (status) {
            case 2:
            case 3:
            case 6:
                return "red"; // Débito
            case 1:
            case 4:
            case 5:
                return "green"; // Crédito
            default:
                return "blue"; // Outros
        }
    };

    const computeItemStatusDescription = (status: number) => {
        switch (status) {
            case 2:
            case 3:
            case 6:
                return "Débito";
            case 1:
            case 4:
            case 5:
                return "Crédito";
            default:
                return "Não se Aplica";
        }
    };
    //#endregion


    return [
        {
            field: "tipoMovimento",
            filterable: false,
            headerName: "Tipo",
            minWidth: 120,
            width: 120,
            sortable: false,
            renderCell: (params) => (
                <div className="w-full h-full flex justify-center items-center">
                    <ItemStatus
                        size="autowidth"
                        title={computeItemStatusTitle(params.value)}
                        color={computeItemStatusColor(params.value)}
                        description={computeItemStatusDescription(params.value)} />
                </div>
            )
        },

        {
            field: "dataMovimento",
            filterable: false,
            headerName: "Data Alteracao",
            flex: 1,
            minWidth: 120,
            sortable: false,
            valueFormatter: (params) => {
                if (!params) return "";
                return new Intl.DateTimeFormat("pt-BR", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                }).format(new Date(params));
            },
        },
        {
            field: "dataPagamento",
            filterable: false,
            headerName: "Data Pagamento /Recebimento",
            flex: 1,
            minWidth: 180,
            sortable: false,
            valueFormatter: (params) => {
                if (!params) return "";
                return new Intl.DateTimeFormat("pt-BR", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                }).format(new Date(params));
            },
        },
        {
            field: "descricao",
            filterable: false,
            headerName: "Tipo de Movimento",
            flex: 1,
            minWidth: 120,
            sortable: false,
        },
        {
            field: "detalhamento",
            filterable: false,
            headerName: "Detalhamento",
            flex: 1,
            minWidth: 120,
            sortable: false,
        },
        {
            field: "valorMovimento",
            filterable: false,
            headerName: "Valor Movimento",
            flex: 1,
            minWidth: 120,
            sortable: false,
            valueFormatter: (params) => {
                if (params == null) return "";
                return new Intl.NumberFormat("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                }).format(params);
            },
        },
        {
            field: "saldoFinal",
            filterable: false,
            headerName: "Saldo Final",
            flex: 1,
            minWidth: 120,
            sortable: false,
            valueFormatter: (params) => {
                if (params == null) return "";
                return new Intl.NumberFormat("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                }).format(params);
            },
        },

    ];

}